/** The one place a path is spelled. Components ask for a route by name. */
export const routes = {
  home: () => "/",
  blog: () => "/blog",
  post: (slug: string) => `/blog/${encodeURIComponent(slug)}`,
  updates: () => "/updates",
  shop: () => "/shop",
  listing: (slug: string) => `/shop/${encodeURIComponent(slug)}`,
  enquiry: (slug: string) => `/contact?listing=${encodeURIComponent(slug)}`,
  contact: () => "/contact",
  privacy: () => "/privacy",
  feed: () => "/feed.xml",
} as const;

export const routePatterns = {
  home: "/",
  blog: "/blog",
  post: "/blog/:slug",
  updates: "/updates",
  shop: "/shop",
  listing: "/shop/:slug",
  contact: "/contact",
  privacy: "/privacy",
} as const;

/** The donate panel is part of whatever page is open, so its state lives in the URL. */
export const DONATE_PARAM = "donate";
